export default __webpack_public_path__ + "static/Brico_Website Privacy Policy v1.0-ede75f649ae40ae8a9c338936e619bad.pdf";